var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProductsNew = function SvgProductsNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.85 9.15 24 3 9.15 9.15 3 24l6.15 14.85L24 45l14.85-6.15L45 24zm-12.6 17.1v7.5h-4.5v-7.5h-7.5v-4.5h7.5v-7.5h4.5v7.5h7.5v4.5z"
  })));
};
export default SvgProductsNew;